import React from 'react';
import { css } from '@emotion/react';
import { useTranslation } from 'react-i18next';

const SmallText = css`
  font-size: 24px;
  font-weight: bold;
`;

const LargeText = css`
  font-size: 46px;
  font-weight: bold;

  span {
    font-size: 16px;
    margin-left: 4px;
  }
`;

export const TimeDisplay = React.memo(({ minutes }: { minutes?: number | null }) => {
  const { t, i18n } = useTranslation();
  if (!minutes) {
    return <div css={LargeText}>-</div>;
  }

  const days = Math.floor(minutes / (60 * 24));
  const hours = Math.floor((minutes % (60 * 24)) / 60);
  const rem = Math.floor(minutes % 60);

  return (
    <>
      <span>{t('average', '平均')}</span>
      {days > 0 && (
        <>
          <span css={LargeText}>{days}</span>
          <span css={SmallText}>{t('days', '日')}</span>
        </>
      )}
      {hours > 0 && (
        <>
          <span css={LargeText}>{hours}</span>
          <span css={SmallText}>{t('hours', '時間')}</span>
        </>
      )}
      {days === 0 && rem > 0 && (
        <>
          <span css={LargeText}>{rem}</span>
          <span css={SmallText}>{t('minutes', '分')}</span>
        </>
      )}
    </>
  );
});
